import { useEffect } from 'react'

const useDocumentClick = (onClick: EventListenerOrEventListenerObject) => {
  useEffect(() => {
    document.addEventListener('click', onClick, { capture: true })

    return () => {
      document.removeEventListener('click', onClick, { capture: true })
    }
  }, [onClick])
}

export default useDocumentClick
